import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import GeneralInformation from '../../sharedcomponents/general-information/general-information';
import '../create-new/createnew.css';
import '../forms/d1/d1.css';
import D1 from '../forms/d1/d1';
import D2 from '../forms/d2/d2';
import D3 from '../forms/d3/d3';
import D4 from '../forms/d4/d4';
import D5 from '../forms/d5/d5';
import D6 from '../forms/d6/d6';
import D7 from '../forms/d7/d7';
import D8 from '../forms/d8/d8';
import { fetchApi } from '../../services/api';
import { getEightDInfoId } from '../../services/eightDInfoStore';
import { getCurrentUserEmail, getCurrentUserName } from '../../services/auth';
import { getEmployeeData } from '../../services/employeeStore';
import inputSanitizationService from '../../services/inputSanitizationService';

import {
  Box,
  Alert
} from '@mui/material';
import clsx from 'clsx';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import Header from '../../sharedcomponents/header/header';

const CreateNew = ({ eightDInfoid, isMatPanelExpanded, toggleSidenav }) => {
  const handleKeyDown = (e) => {
    const tag = e.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA') {
      // Skip readOnly inputs (e.g., date pickers)
      if (e.target.readOnly || e.target.getAttribute('readonly') !== null) {
        return;
      }
      // Check if input is safe
      if (!inputSanitizationService.isSafeInput(e.key)) {
        e.preventDefault();
        inputSanitizationService.showValidationError(['Invalid character detected and blocked']);
      }
    }
  };
  
  const handlePaste = (e) => {
    const tag = e.target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA') {
      // Skip readOnly inputs (e.g., date pickers)
      if (e.target.readOnly || e.target.getAttribute('readonly') !== null) {
        return;
      }
      const pasted = e.clipboardData.getData('text');
      const validation = inputSanitizationService.sanitizeInput(pasted);
      
      if (!validation.isValid) {
        e.preventDefault();
        inputSanitizationService.showValidationError(validation.errors);
        // Insert sanitized version instead
        document.execCommand('insertText', false, validation.sanitized);
      }
    }
  };
  
  const handleInput = (e) => {
    const tag = e.target.tagName;
    const inputType = e.target.type;
    
    // Skip file inputs as they cannot be programmatically modified
    if (inputType === 'file') {
      return;
    }

    // Skip readOnly inputs (e.g., date pickers that are populated programmatically)
    if (e.target.readOnly || e.target.getAttribute('readonly') !== null) {
      return;
    }
    
    if (tag === 'INPUT' || tag === 'TEXTAREA') {
      const sanitizeType = inputType === 'email' ? 'email' : 
                          inputType === 'tel' ? 'phone' : 
                          tag === 'TEXTAREA' ? 'textarea' : 'text';
      
      const sanitized = inputSanitizationService.realTimeSanitize(e.target.value, sanitizeType);
      
      if (sanitized !== e.target.value) {
        e.target.value = sanitized;
        inputSanitizationService.showValidationError(['Input has been automatically sanitized']);
      }
    }
  };
  const location = useLocation();
    const { eightDInfoId: routeEightDInfoId, mode, reportData: apiReportData, d1Data: initialD1Data, d2Data, d2ResponsibleData, d3Data, d3ResponsibleData, d4Data, d4ResponsibleData, d5Data, d5ResponsibleData, d6Data, d6ResponsibleData, d7Data, d7ResponsibleData, d8Data, currentUserEmail, isDrafted } = location.state || {};
  const isEditMode = mode === 'edit' && (routeEightDInfoId || apiReportData);
  const [d1Data, setD1Data] = useState(initialD1Data);

  // Resolved eightDInfoId: from route (edit mode) or from global store (create mode)
  const [resolvedEightDInfoId, setResolvedEightDInfoId] = useState(routeEightDInfoId || getEightDInfoId() || null);

  // State management
  const [formModeUpdate, setFormModeUpdate] = useState(isEditMode);
  const [eightDForm, setEightDForm] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [currentUser, setCurrentUser] = useState({ emailid: '' });
  const [reportData, setReportData] = useState(null);
  const [d1DataLoaded, setD1DataLoaded] = useState(false);
  //const isDisabled = eightDInfoid === undefined;

  // Initialize component
  useEffect(() => {
    setCurrentUser({ emailid: 'user1@example.com' });

    // Load D1 data if available
    const mapRole = (member) => {
      const mr = (member.MemberRole || '').toLowerCase();
      if (mr === 'originator') return 'o';
      if (mr === 'coordinator') return 'c';
      return '';
    };

    const mapMember = (member) => ({
      d1Id: member.D1Id || null,
      email: member.EmailId || '',
      name: member.TeamMemberName || '',
      mobile: member.MobileNo || '',
      role: mapRole(member),
      memberRole: (member.MemberRole || '').toLowerCase() === 'originator' ? '' : (member.MemberRole || ''),
      division: member.Division || '',
      createdBy: member.CreatedBy,
      createdOn: member.CreatedOn,
      modifiedBy: member.ModifiedBy,
      modifiedOn: member.ModifiedOn
    });

    // In edit mode, fetch fresh D1 data from API instead of relying on stale location.state
    // Only fetch if we haven't loaded D1 data yet
    if (isEditMode && routeEightDInfoId && !d1DataLoaded) {
      setD1DataLoaded(true);
      const fetchFreshD1 = async () => {
        try {

          const response = await fetchApi('/api/D1/GetD1', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ EightDInfoId: Number(routeEightDInfoId) }),
          });
          const freshData = response?.data;
          if (freshData && Array.isArray(freshData) && freshData.length > 0) {
            const activeData = freshData.filter(m => !m.IsDeleted);
            const roleOrder = { Originator: 0, Coordinator: 1 };
            const sorted = [...activeData].sort((a, b) => (roleOrder[a.MemberRole] ?? 2) - (roleOrder[b.MemberRole] ?? 2) || (a.D1Id || 0) - (b.D1Id || 0));
            setD1Data(sorted);
            setMembers(sorted.map(mapMember));
            setTeamMembers(sorted);
            setGeneralInfoSaved(true);
            setD1Saved(true);
          }
        } catch (error) {
          if (initialD1Data && Array.isArray(initialD1Data) && initialD1Data.length > 0) {
            setMembers(initialD1Data.map(mapMember));
            setTeamMembers(initialD1Data);
            setGeneralInfoSaved(true);
            setD1Saved(true);
          }
        }
      };
      fetchFreshD1();
    } else if (d1Data && Array.isArray(d1Data) && d1Data.length > 0) {
      setMembers(d1Data.map(mapMember));
      setTeamMembers(d1Data);
      setGeneralInfoSaved(true);
      setD1Saved(true);
    } else if (d1Data && d1Data.data && Array.isArray(d1Data.data) && d1Data.data.length > 0) {
      setMembers(d1Data.data.map(mapMember));
      setTeamMembers(d1Data.data);
      setGeneralInfoSaved(true);
      setD1Saved(true);
    }

    // Enable D2-D7 if data exists (edit mode)
    if (d2Data || d2ResponsibleData) {
      setD2Saved(true);
    }
    if (d3Data || d3ResponsibleData) {
      setD3Saved(true);
    }
    if (d4Data || d4ResponsibleData) {
      setD4Saved(true);
    }
    if (d5Data || d5ResponsibleData) {
      setD5Saved(true);
    }
    if (d6Data || d6ResponsibleData) {
      setD6Saved(true);
    }
    if (d7Data || d7ResponsibleData) {
      setD7Saved(true);
    }

    // Load report data from API response
    if (apiReportData) {
      setFormModeUpdate(true);
      const data = apiReportData.data || apiReportData;
      const mappedData = {
        reportNo: data.ReportNo,
        problemStatement: data.ProblemStatement,
        partDescription: data.PartDescription,
        sourceOfComplain: data.SourceOfComplain,
        partNo: data.PartNo,
        startDate: data.StartDate ? new Date(data.StartDate) : null,
        supplierName: data.SupplierName,
        severityPoints: data.SeverityPoints,
        isRecurringIssue: data.IsRecurringIssue,
        isCustomerSafetyEffect: data.IsCustomerSafetyEffect
      };
      setReportData(mappedData);
    }
  }, [isEditMode, apiReportData]); // eslint-disable-line

  // Debug: Log teamMembers whenever it changes
  useEffect(() => {
  }, [teamMembers]);

  const loggedInUserEmail = getCurrentUserEmail() || sessionStorage.getItem('userEmail') || '';
  const originatorEmail = currentUserEmail || loggedInUserEmail;

  // Simple readOnly logic: fetch responsible person per form, compare with logged-in email
  const [formAccess, setFormAccess] = useState({ d2: false, d3: false, d4: false, d5: false, d6: false, d7: false });

  useEffect(() => {
    if (!isEditMode || !resolvedEightDInfoId || !loggedInUserEmail) return;

    const fetchAccess = async () => {
      try {
        const body = JSON.stringify({ EightDInfoId: Number(resolvedEightDInfoId) });
        const opts = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body };
        const [d2, d3, d4, d5, d6, d7] = await Promise.all([
          fetchApi('/api/D2/GetD2', opts).catch(() => null),
          fetchApi('/api/D3/GetD3', opts).catch(() => null),
          fetchApi('/api/D4/GetD4', opts).catch(() => null),
          fetchApi('/api/D5/GetD5', opts).catch(() => null),
          fetchApi('/api/D6/GetD6', opts).catch(() => null),
          fetchApi('/api/D7/GetD7', opts).catch(() => null),
        ]);

        const email = loggedInUserEmail.toLowerCase();
        const getRp = (resp) => (resp?.data?.ResponsiblePerson || resp?.data?.responsiblePerson || '').toLowerCase();

        const access = {
          d2: getRp(d2) === email,
          d3: getRp(d3) === email,
          d4: getRp(d4) === email,
          d5: getRp(d5) === email,
          d6: getRp(d6) === email,
          d7: getRp(d7) === email,
        };

        setFormAccess(access);
      } catch (e) {
        console.error('[CreateNew] Failed to fetch form access:', e);
      }
    };
    fetchAccess();
  }, [isEditMode, resolvedEightDInfoId, loggedInUserEmail]); // eslint-disable-line

  // Get employee data for pre-filling originator details
  const employeeData = getEmployeeData();
  const getOriginatorDetails = () => {
    if (!originatorEmail) return [];
    if (!originatorEmail.toLowerCase().endsWith('@godrej.com')) {
      console.warn('Originator must be a Godrej user');
      return [];
    }
    const originatorName = employeeData?.shortName || employeeData?.teamMemberName || employeeData?.name || getCurrentUserName() || '';
    const originatorMobile = employeeData?.mobileNo || employeeData?.mobile || '';
    const originatorDiv = employeeData?.divCode || employeeData?.Division_Code || '';
    return [{ email: originatorEmail, name: originatorName, mobile: originatorMobile, role: 'o', division: originatorDiv }];
  };

  // members MUST be declared before isOriginator useMemo to avoid TDZ ReferenceError
  const [members, setMembers] = useState(isEditMode ? [] : getOriginatorDetails());

  useEffect(() => {
    if (!isEditMode && members.length === 0 && loggedInUserEmail) {
      const details = getOriginatorDetails();
      if (details.length > 0) setMembers(details);
    }
  }, [loggedInUserEmail]); // eslint-disable-line react-hooks/exhaustive-deps

  // Check if user is originator (originator can edit everything)
  const isOriginator = useMemo(() => {
    if (!loggedInUserEmail) return false;
    if (!isEditMode) return true;
    const orig = members.find(m => m.role === 'o');
    if (orig) return orig.email.toLowerCase() === loggedInUserEmail.toLowerCase();
    const d1List = initialD1Data || [];
    const dataArr = Array.isArray(d1List) ? d1List : (d1List?.data || []);
    const origFromState = dataArr.find(m => (m.MemberRole || '').toLowerCase() === 'originator');
    if (origFromState) return (origFromState.EmailId || '').toLowerCase() === loggedInUserEmail.toLowerCase();
    return false;
  }, [loggedInUserEmail, isEditMode, members, initialD1Data]);

  const getReadOnly = (formKey) => {
    if (!isEditMode) return false;
    if (isOriginator) return false;
    return !formAccess[formKey];
  };

  const [newMember, setNewMember] = useState({ email: "", name: "", mobile: "", division: "" });
  // Handler functions
  const setEightDidToFormGroup = (data) => {
    setEightDForm(data);
    // After GeneralInformation saves, pick up the eightDInfoId from callback or global store
    const newId = data?.eightDInfoId || getEightDInfoId();
    if (newId) {
      setResolvedEightDInfoId(newId);
    }
    setGeneralInfoSaved(true);
  };

  const [expandedSection, setExpandedSection] = useState(null);
  const [generalInfoSaved, setGeneralInfoSaved] = useState(isEditMode ? true : false);
  const [d1Saved, setD1Saved] = useState(isEditMode ? true : false);
  const [d2Saved, setD2Saved] = useState(false);
  const [d3Saved, setD3Saved] = useState(false);
  const [d4Saved, setD4Saved] = useState(false);
  const [d5Saved, setD5Saved] = useState(false);
  const [d6Saved, setD6Saved] = useState(false);
  const [d7Saved, setD7Saved] = useState(false);

  const handleExpand = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleD1Saved = async (savedData) => {

    
    setD1Saved(true);
    setD2Saved(true);
    setD3Saved(true);
    setD4Saved(true);
    setD5Saved(true);
    setD6Saved(true);
    setD7Saved(true);
    
    const sortD1 = (arr) => {
      const roleOrder = { Originator: 0, Coordinator: 1 };
      return [...arr].sort((a, b) => (roleOrder[a.MemberRole] ?? 2) - (roleOrder[b.MemberRole] ?? 2) || (a.D1Id || 0) - (b.D1Id || 0));
    };

    // Only update teamMembers (for D2-D8 dropdowns), NOT members (D1's local state)
    if (savedData && savedData.data && Array.isArray(savedData.data) && savedData.data.length > 0) {

      const activeData = savedData.data.filter(m => !m.IsDeleted);
      const sorted = sortD1(activeData);
      setTeamMembers(sorted);
    }
    

  };
  const [d8ValidationAlert, setD8ValidationAlert] = useState(false);

  // Track which forms have a responsible person assigned (either from props or set in current session)
  const [responsibleAssigned, setResponsibleAssigned] = useState(() => {
    const responsibleDataList = [d2ResponsibleData, d3ResponsibleData, d4ResponsibleData, d5ResponsibleData, d6ResponsibleData, d7ResponsibleData];
    return responsibleDataList.some(rd => {
      if (!rd) return false;
      const item = Array.isArray(rd) ? rd[0] : rd;
      return !!(item?.ResponsiblePerson || item?.responsiblePerson);
    });
  });

  // Check if any D2-D7 form has a responsible person assigned
  const checkResponsiblePersonAssigned = () => {
    const responsibleDataList = [d2ResponsibleData, d3ResponsibleData, d4ResponsibleData, d5ResponsibleData, d6ResponsibleData, d7ResponsibleData];
    const hasResponsibleFromProps = responsibleDataList.some(rd => {
      if (!rd) return false;
      const item = Array.isArray(rd) ? rd[0] : rd;
      return !!(item?.ResponsiblePerson || item?.responsiblePerson);
    });
    return hasResponsibleFromProps || responsibleAssigned;
  };

  const handleD8Expand = async () => {
    // In edit mode, fetch live responsible person data from API
    if (isEditMode && resolvedEightDInfoId && !responsibleAssigned) {
      try {
        const body = JSON.stringify({ EightDInfoId: Number(resolvedEightDInfoId) });
        const opts = { method: 'POST', headers: { 'Content-Type': 'application/json' }, body };
        const [d2Resp, d3Resp, d4Resp, d5Resp, d5RespResp, d6Resp, d7Resp] = await Promise.all([
          fetchApi('/api/D2/GetD2', opts).catch(() => null),
          fetchApi('/api/D3/GetD3', opts).catch(() => null),
          fetchApi('/api/D4/GetD4', opts).catch(() => null),
          fetchApi('/api/D5/GetD5', opts).catch(() => null),
          fetchApi('/api/D5/GetD5Responsible', opts).catch(() => null),
          fetchApi('/api/D6/GetD6', opts).catch(() => null),
          fetchApi('/api/D7/GetD7', opts).catch(() => null),
        ]);
        const hasRP = [d2Resp, d3Resp, d4Resp, d5Resp, d5RespResp, d6Resp, d7Resp].some(resp => {
          const item = resp?.data;
          return !!(item?.ResponsiblePerson || item?.responsiblePerson);
        });
        if (hasRP) {
          setResponsibleAssigned(true);
          setD8ValidationAlert(false);
          handleExpand('D8');
          return;
        }
      } catch (e) {
        // fall through to normal check
      }
    }
    if (!checkResponsiblePersonAssigned()) {
      setD8ValidationAlert(true);
      setTimeout(() => setD8ValidationAlert(false), 2000);
      return;
    }
    setD8ValidationAlert(false);
    handleExpand('D8');
  };

  const hasResponsibleInResponse = (response) => {
    const item = Array.isArray(response?.data) ? response.data[0] : response?.data;
    return !!(item?.ResponsiblePerson || item?.responsiblePerson);
  };
  const handleD2Saved = (response) => {
    setD2Saved(true);
    if (hasResponsibleInResponse(response)) setResponsibleAssigned(true);
  };
  const handleD3Saved = (response) => {
    setD3Saved(true);
    if (hasResponsibleInResponse(response)) setResponsibleAssigned(true);
  };
  const handleD4Saved = (response) => {
    setD4Saved(true);
    if (hasResponsibleInResponse(response)) setResponsibleAssigned(true);
  };
  const handleD5Saved = (response) => {
    setD5Saved(true);
    if (hasResponsibleInResponse(response)) setResponsibleAssigned(true);
  };
  const handleD6Saved = (response) => {
    setD6Saved(true);
    if (hasResponsibleInResponse(response)) setResponsibleAssigned(true);
  };
  const handleD7Saved = (response) => {
    setD7Saved(true);
    if (hasResponsibleInResponse(response)) setResponsibleAssigned(true);
  };
  return (
    <Header>
      <div className="container-fluid" 
        onKeyDown={handleKeyDown} 
        onPaste={handlePaste} 
        onInput={handleInput}
        style={{height: '100vh', overflowY: 'auto', overflowX: 'hidden', padding: '15px', boxSizing: 'border-box'}}>
        <div className="col-12 pl-0 pr-0">
          <div className="mainContent pl-0 pr-0">
            {!formModeUpdate && <div className="PageTitle"></div>}
          </div>
          <div className="clearfix"></div>
        </div>

        <div className="generalInformations">
          <GeneralInformation
            key={reportData ? 'edit-mode' : 'create-mode'}
            onChildChanged={setEightDidToFormGroup}
            formModeUpdate={formModeUpdate}
            reportData={reportData}
            readOnly={true}
            generalInfoSaved={generalInfoSaved}
          />

          <section className="col-12">
            <h2 className="pt-4">All 8D Forms</h2>

            {/* ✅ D1 */}
              <Box className="pt-4" style={{ display: (!expandedSection || expandedSection === 'D1') ? 'block' : 'none' }}>
                <D1
                  expanded={expandedSection === "D1"}
                  members={members}
                  newMember={newMember}
                  handleCloseForm={() => setExpandedSection(null)}
                  setNewMember={setNewMember}
                  setMembers={setMembers}
                  onFillClick={() => handleExpand("D1")}
                  onToggleAccordion={() => handleExpand("D1")}
                  onSaved={handleD1Saved}
                  isEnabled={generalInfoSaved || isEditMode}
                  eightDInfoId={resolvedEightDInfoId}
                  currentUserEmail={currentUserEmail}
                  readOnly={isEditMode && !isOriginator}
                  d1Data={d1Data}
                  d1Saved={d1Saved}
                  isDrafted={isDrafted}
                />
              </Box>

            {/* ✅ D2 */}
              <Box className="pt-4" style={{ display: (!expandedSection || expandedSection === 'D2') ? 'block' : 'none' }}>
                <D2
                  expanded={expandedSection === "D2"}
                  onSetClick={() => handleExpand("D2")}
                  handleCloseForm={() => setExpandedSection(null)}
                  onToggleAccordion={() => handleExpand("D2")}
                  isEnabled={d1Saved || isEditMode}
                  onSaved={handleD2Saved}
                  onResponsibleSet={() => setResponsibleAssigned(true)}
                  eightDInfoId={resolvedEightDInfoId}
                  currentUserEmail={currentUserEmail}
                  teamMembers={teamMembers}
                  d2Data={d2Data}
                  d2ResponsibleData={d2ResponsibleData}
                  readOnly={getReadOnly('d2')}
                  mode={mode}
                />
              </Box>

            {/* ✅ D3 */}
              <Box className="pt-4" style={{ display: (!expandedSection || expandedSection === 'D3') ? 'block' : 'none' }}>
                <D3
                  expanded={expandedSection === "D3"}
                  onSetClick={() => handleExpand("D3")}
                  handleCloseForm={() => setExpandedSection(null)}
                  onToggleAccordion={() => handleExpand("D3")}
                  isEnabled={d1Saved || isEditMode}
                  onSaved={handleD3Saved}
                  onResponsibleSet={() => setResponsibleAssigned(true)}
                  eightDInfoId={resolvedEightDInfoId}
                  currentUserEmail={currentUserEmail}
                  teamMembers={teamMembers}
                  d3Data={d3Data}
                  d3ResponsibleData={d3ResponsibleData}
                  readOnly={getReadOnly('d3')}
                  mode={mode}
                />
              </Box>

            {/* ✅ D4 */}
              <Box className="pt-4" style={{ display: (!expandedSection || expandedSection === 'D4') ? 'block' : 'none' }}>
                <D4
                  expanded={expandedSection === "D4"}
                  onSetClick={() => handleExpand("D4")}
                  handleCloseForm={() => setExpandedSection(null)}
                  onToggleAccordion={() => handleExpand("D4")}
                  isEnabled={d1Saved || isEditMode}
                  onSaved={handleD4Saved}
                  onResponsibleSet={() => setResponsibleAssigned(true)}
                  eightDInfoId={resolvedEightDInfoId}
                  currentUserEmail={currentUserEmail}
                  teamMembers={teamMembers}
                  d4Data={d4Data}
                  d4ResponsibleData={d4ResponsibleData}
                  readOnly={getReadOnly('d4')}
                  mode={mode}
                />
              </Box>

            {/* ✅ D5 */}
              <Box className="pt-4" style={{ display: (!expandedSection || expandedSection === 'D5') ? 'block' : 'none' }}>
                <D5
                  expanded={expandedSection === "D5"}
                  onSetClick={() => handleExpand("D5")}
                  handleCloseForm={() => setExpandedSection(null)}
                  onToggleAccordion={() => handleExpand("D5")}
                  isEnabled={d1Saved || isEditMode}
                  onSaved={handleD5Saved}
                  onResponsibleSet={() => setResponsibleAssigned(true)}
                  eightDInfoId={resolvedEightDInfoId}
                  currentUserEmail={currentUserEmail}
                  teamMembers={teamMembers}
                  d5Data={d5Data}
                  d5ResponsibleData={d5ResponsibleData}
                  readOnly={getReadOnly('d5')}
                  mode={mode}
                />
              </Box>

            {/* ✅ D6 */}
              <Box className="pt-4" style={{ display: (!expandedSection || expandedSection === 'D6') ? 'block' : 'none' }}>
                <D6
                  expanded={expandedSection === "D6"}
                  onSetClick={() => handleExpand("D6")}
                  handleCloseForm={() => setExpandedSection(null)}
                  onToggleAccordion={() => handleExpand("D6")}
                  isEnabled={d1Saved || isEditMode}
                  onSaved={handleD6Saved}
                  onResponsibleSet={() => setResponsibleAssigned(true)}
                  eightDInfoId={resolvedEightDInfoId}
                  currentUserEmail={currentUserEmail}
                  teamMembers={teamMembers}
                  d6Data={d6Data}
                  d6ResponsibleData={d6ResponsibleData}
                  readOnly={getReadOnly('d6')}
                  mode={mode}
                />
              </Box>

            {/* ✅ D7 */}
              <Box className="pt-4" style={{ display: (!expandedSection || expandedSection === 'D7') ? 'block' : 'none' }}>
                <D7
                  expanded={expandedSection === "D7"}
                  onSetClick={() => handleExpand("D7")}
                  handleCloseForm={() => setExpandedSection(null)}
                  onToggleAccordion={() => handleExpand("D7")}
                  isEnabled={d1Saved || isEditMode}
                  onSaved={handleD7Saved}
                  onResponsibleSet={() => setResponsibleAssigned(true)}
                  eightDInfoId={resolvedEightDInfoId}
                  currentUserEmail={currentUserEmail}
                  teamMembers={teamMembers}
                  d7Data={d7Data}
                  d7ResponsibleData={d7ResponsibleData}
                  readOnly={getReadOnly('d7')}
                  mode={mode}
                />
              </Box>

            {/* ✅ D8 */}
              <Box className="pt-4" style={{ display: (!expandedSection || expandedSection === 'D8') ? 'block' : 'none' }}>
                {d8ValidationAlert && (
                  <Alert severity="warning" onClose={() => setD8ValidationAlert(false)} sx={{ mb: 2 }}>
                    Please assign at least one form (D2 to D7) to a Responsible Person.
                  </Alert>
                )}
                <D8
                  expanded={expandedSection === "D8"}
                  onSetClick={() => handleD8Expand()}
                  handleCloseForm={() => setExpandedSection(null)}
                  onToggleAccordion={() => handleD8Expand()}                  isEnabled={d1Saved || isEditMode}
                  eightDInfoId={resolvedEightDInfoId}
                  currentUserEmail={currentUserEmail}
                  readOnly={isEditMode && !isOriginator}
                  d8Data={d8Data}
                  mode={mode}
                  teamMembers={teamMembers}
                  d3ResponsibleData={d3ResponsibleData}
                  d4ResponsibleData={d4ResponsibleData}
                  d5ResponsibleData={d5ResponsibleData}
                  d6ResponsibleData={d6ResponsibleData}
                  d7ResponsibleData={d7ResponsibleData}
                  d2ResponsibleData={d2ResponsibleData}
                />
              </Box>
          </section>
        </div>
      </div>
    </Header>
  );
};

export default CreateNew;
//    return (
//     <Header>
//       <div className="container-fluid">
//         <div className="col-12 pl-0 pr-0">
//           <div className="mainContent pl-0 pr-0">
//             {!formModeUpdate && (
//               <div className="PageTitle">
//                 {/* Page title content if needed */}
//               </div>
//             )}
//           </div>
//           <div className="clearfix"></div>
//         </div>

//         <div className="generalInformations">
//           <GeneralInformation onChildChanged={setEightDidToFormGroup} formModeUpdate={formModeUpdate} />

//           <section className="col-12">
//             <h2 className="pt-4">All 8D Forms</h2>
//             {/* -------------------------D1------------------------------- */}
//             <div>
//               <Box className="pt-4">
//                 {/* Header */}
//                 <D1
//                   expanded={expandedD1}
//                   members={members}
//                   newMember={newMember}
//                   handleCloseForm={handleCloseD1}
//                   setNewMember={setNewMember}
//                   setMembers={setMembers}
//                   onFillClick={handleFillClickD1}
//                 />
//               </Box>
//             </div>
//              {/* -------------------------D2------------------------------- */}
//             <div>
//               <Box className="pt-4">
//                 {/* Header */}
//                 <D2
//                  expanded={expandedD2}
//                  onSetClick={handleSetClickD2}
//                  handleCloseForm={handleCloseD2}
//                 />
//               </Box>
//             </div>
//             {/* -------------------------D3------------------------------- */}
//             <div>
//               <Box className="pt-4">
//                 {/* Header */}
//                 <D3
//                  expanded={expandedD3}
//                  onSetClick={handleSetClickD3}
//                  handleCloseForm={handleCloseD3}/>
//               </Box>
//             </div>
//             {/* -------------------------D4------------------------------- */}
//             <div>
//               <Box className="pt-4">
//                 {/* Header */}
//                 <D4
//                  expanded={expandedD4}
//                  onSetClick={handleSetClickD4}
//                  handleCloseForm={handleCloseD4}/>
//               </Box>
//             </div>
//             {/* -------------------------D5------------------------------- */}
//             <div>
//               <Box className="pt-4">
//                 {/* Header */}
//                 <D5
//                  expanded={expandedD5}
//                  onSetClick={handleSetClickD5}
//                  handleCloseForm={handleCloseD5}/>
//               </Box>
//             </div>
//             {/* -------------------------D6------------------------------- */}
//             <div>
//               <Box className="pt-4">
//                 {/* Header */}
//                 <D6
//                  expanded={expandedD6}
//                  onSetClick={handleSetClickD6}
//                  handleCloseForm={handleCloseD6}/>
//               </Box>
//             </div>
//              {/* -------------------------D7------------------------------- */}
//             <div>
//               <Box className="pt-4">
//                 {/* Header */}
//                 <D7
//                  expanded={expandedD7}
//                  onSetClick={handleSetClickD7}
//                  handleCloseForm={handleCloseD7}/>
//               </Box>
//             </div>
//             {/* -------------------------D8------------------------------- */}
//             <div>
//               <Box className="pt-4">
//                 {/* Header */}
//                 <D8
//                  expanded={expandedD8}
//                  onSetClick={handleSetClickD8}
//                  handleCloseForm={handleCloseD8}/>
//               </Box>
//             </div>
//           </section>
//         </div>
//       </div>
//     </Header>
//   );
// };

// export default CreateNew;
